import _ from 'lodash';
import * as ActionType from '../actions/actionType';
import { getSettingsApi } from '../services/settings';

const getSettingsAction = () => {
  return async dispatch => {
    dispatchSettings(dispatch);
  };
};

const dispatchSettings = dispatch => {
  getSettingsApi().then(data => {
    const defaultLanguage = _.get(data, 'defaultLanguage');
    dispatch({
      type: ActionType.SWITCH_LANGUAGE,
      language: defaultLanguage
    });
    return {
      data,
      defaultLanguage
    };
  });
};

export { getSettingsAction, dispatchSettings };



// WEBPACK FOOTER //
// ./src/actions/settings.js